import React from 'react';
import { Building2, EyeOff, ShieldCheck, UsersRound } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

const accessRules = [
  { icon: Building2, title: 'Immobili assegnati', detail: 'Ogni collaboratore sarà collegato solo agli immobili scelti dal gestore.' },
  { icon: ShieldCheck, title: 'Dati separati', detail: 'Prenotazioni, ospiti e attività resteranno limitati agli immobili assegnati.' },
  { icon: EyeOff, title: 'Guadagni riservati', detail: 'Ricavi, margini e informazioni economiche resteranno visibili solo al gestore.' },
];

export default function HomeSmartCollaborators() {
  return (
    <div className="mx-auto max-w-5xl space-y-8 px-4 pb-6 pt-16 md:px-8 md:pt-6" data-testid="home-smart-collaborators-page">
      <header className="border-b border-slate-200 pb-6">
        <p className="text-sm font-bold uppercase text-blue-700">Home Smart</p>
        <h1 className="mt-1 text-3xl font-bold text-slate-950" data-testid="collaborators-title">Collaboratori</h1>
        <p className="mt-2 max-w-2xl text-slate-600" data-testid="collaborators-description">
          L’area per assegnare immobili e attività alle persone che ti aiutano nella gestione.
        </p>
      </header>

      <section className="space-y-4" data-testid="collaborators-access-rules">
        <h2 className="text-lg font-bold text-slate-950">Regole di accesso predisposte</h2>
        <div className="grid gap-4 md:grid-cols-3">
          {accessRules.map(({ icon: Icon, title, detail }, index) => (
            <Card key={title} className="border-slate-200" data-testid={`collaborator-rule-${index + 1}`}>
              <CardContent className="pt-6">
                <span className="mb-5 flex h-10 w-10 items-center justify-center rounded-md bg-blue-700 text-white">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="font-bold text-slate-950">{title}</h3>
                <p className="mt-2 text-sm leading-6 text-slate-600">{detail}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      <div className="flex min-h-44 flex-col items-center justify-center border border-dashed border-blue-300 bg-blue-50 px-5 text-center" data-testid="collaborators-empty-state">
        <UsersRound className="h-9 w-9 text-blue-700" />
        <p className="mt-4 font-bold text-slate-950">Nessun collaboratore inserito</p>
        <p className="mt-1 text-sm text-slate-600">La gestione degli inviti e delle assegnazioni sarà completata nella prossima fase.</p>
      </div>
    </div>
  );
}